import { URL_CTRL_TRASP } from '../router/Url';

export const GetUserTransport = ({data}) => {
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_CTRL_TRASP+'finduser',{
      method: 'POST',
      headers: {
        'authorization': "paico2021",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        data
      })
    })
    let responsito = await query.json();
    // console.log(responsito)
    if(responsito.success){
      resolve(responsito.body)
    }else{
      resolve(responsito.body)
    }
  })
}
